<template>
  <Dialog
    :visible.sync="visible"
    :title="$t('game.getInvoiceTitle')"
    @close="$emit('goShopping')"
    @touchmove.native.prevent
  >
    <template #title>
      <div class="custom-header" :class="maskstyle === 'success' ? 'success' : 'err'">
        <div class="custom-header-title">
          {{
            maskstyle === 'success'
              ? $t('game.paySuccess')
              : maskstyle === 'deliveryfail'
                ? $t('game.deliveryFail')
                : $t('game.payFail')
          }}
        </div>
      </div>
    </template>
    <div class="pay-result-container">
      <div class="tips">
        <template v-if="maskstyle == 'deliveryfail'">{{ $t('game.deliveryFailTips') }}</template>
        <template v-if="maskstyle == 'success'">
          <template v-if="orderinfo.pending_review === 1">
            <div v-html="$t('pay.paypalTipsAudit')"></div>
          </template>
          <template v-else>
            {{ $t('game.paySuccessTips') }}
            <div>{{ $t('game.paySuccessTips2') }}</div>
          </template>
        </template>
        <div
          v-if="maskstyle == 'payfail'"
          class="fail-code"
          v-html="$t(orderinfo.fail_code || 'fail.change')"
        ></div>
      </div>
      <div class="pay-result-content">
        <div class="pay-result-section">
          <p>
            <span>{{ $t('game.paidWith') }}</span>
            <span>{{ invoicetext(paysty) }}</span>
          </p>
          <p v-if="orderinfo.OrderID != ''">
            <span>{{ $t('game.orderID') }}</span>
            <span>{{ orderinfo.OrderID }}</span>
          </p>
          <p>
            <span>{{ $t('game.payStatus') }}</span>
            <span v-if="maskstyle == 'payfail'">{{ $t('game.camelPayfail') }}</span>
            <span v-else-if="maskstyle == 'deliveryfail'">{{ $t('game.camelDeliveryFail') }}</span>
            <span v-else-if="maskstyle == 'success'">{{ $t('game.camelPaySuccess') }}</span>
            <span v-else>{{ maskstyle }}</span>
          </p>
          <p v-if="!isShowTax">
            <span>{{ $t('game.orderTotal') }}</span>
            <span>{{ moneyUnit }} {{ orderinfo.real_amount | formatPrice }}</span>
          </p>
          <p v-if="orderinfo.localDate != ''">
            <span>{{ $t('game.transactionDate') }}</span>
            <span>{{ orderinfo.localDate }}</span>
          </p>
        </div>
        <div class="pay-result-section" v-if="isShowTax">
          <p>
            <span>{{ $t('tax.prodPrice') }}</span>
            <span
              >{{ moneyUnit }}
              {{ (orderinfo.real_amount || payinfo.real_amount) | formatPrice }}</span
            >
          </p>
          <p>
            <span>{{ $t('tax.taxPrice') }}</span>
            <span>{{ moneyUnit }} {{ (orderinfo.tax || payinfo.tax) | formatPrice }}</span>
          </p>
          <p>
            <span>{{ $t('tax.totalPrice') }}</span>
            <span
              >{{ moneyUnit }}
              {{ (orderinfo.taxed_price || payinfo.taxed_price) | formatPrice }}</span
            >
          </p>
        </div>
        <template v-if="(maskstyle == 'success' || maskstyle == 'deliveryfail') && !emailSended">
          <div class="send-to-email medium" @click="$emit('sendToEmail')">
            <div class="icon"></div>
            <div class="txt">{{ $t('invoice.button1') }}</div>
          </div>
        </template>
      </div>
    </div>
    <template #footer>
      <div class="footer-container">
        <template v-if="maskstyle == 'success' || maskstyle == 'deliveryfail'">
          <div class="button" @click="goToGame" v-if="isShowGoToGame">
            <AutoFitComponent align="center">
              <i18n path="btn.backToGame" tag="div" class="flex">
                <div place="logo" class="icon_logo icon_logo_btn" :class="$i18n.locale"></div>
              </i18n>
            </AutoFitComponent>
          </div>
          <div class="button" :class="{ plain: isShowGoToGame }" @click="$emit('goShopping')">
            {{ $t('btn.goShopping') }}
          </div>
        </template>
        <template v-else>
          <div
            v-if="orderinfo.fail_code === 'pay.limitPackBuyFail'"
            class="button"
            @click="refresh"
          >
            {{ $t('game.okbtn') }}
          </div>
          <div v-else class="button" @click="$emit('payAgain')">{{ $t('game.goOnPay') }}</div>
        </template>
      </div>
    </template>
  </Dialog>
</template>

<script>
// import导入组件工具等
import { mapState } from 'vuex'
export default {
  props: [
    'orderinfo',
    'paysty',
    'moneyUnit',
    'maskstyle',
    'ru_psp_payment_type',
    'payinfo',
    'emailSended',
  ],
  data() {
    return {
      visible: false,

      timer: null,
    }
  },
  created() {
    this.visible = true
    console.log('orderinfo======', { ...this.orderinfo })
    console.log('payinfo======', { ...this.payinfo })
  },
  // 组件方法
  methods: {
    refresh() {
      this.$emit('close')
      this.$emit('refresh')
    },
    invoicetext(paysty) {
      var paymentLabel

      switch (paysty) {
        case 'kakao':
          paymentLabel = this.$t('paymentMethod.KakaoPay')
          break
        case 'paypay':
          paymentLabel = 'PayPay'
          break
        case 'paypal':
          paymentLabel = 'PayPal'
          break
        case 'google_pay':
          paymentLabel = 'Google Pay'
          break
        case 'apple_pay':
          paymentLabel = 'Apple Pay'
          break
        case 'payermax':
          paymentLabel = this.ru_psp_payment_type
          break
        case 'deepgrow':
          paymentLabel = this.ru_psp_payment_type
          break
        default:
          paymentLabel = 'Card'
      }

      return paymentLabel
    },
    goToGame() {
      const url = this.$utils.buildScheme(this.gameScheme.scheme, this.gameScheme.universal_link)

      document.addEventListener('visibilitychange', this.handleVisibilityChange)

      this.clearTimer()
      this.timer = setTimeout(() => {
        this.$toast(this.$t('toast.downloadGameToUse'))
      }, 5000)

      if (window.self !== window.top) {
        //console.log("页面是在 iframe 中打开的");
        window.open(url)
      } else {
        //console.log("页面不是在 iframe 中打开的");
        window.location.href = url
      }
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.$emit('goShopping')
      }
      this.clearTimer()
    },
  },
  // 计算属性
  computed: {
    ...mapState({
      gameScheme: (state) => state.app.gameScheme,
      isMobile: (state) => state.app.isMobile,
      isProductionTax: (state) => state.app.isProductionTax,
      h5LoginWays: (state) => state.config.gameConfig.mobile_login_list,
    }),
    isShowGoToGame() {
      return (
        this.h5LoginWays.includes('app') &&
        this.gameScheme.scheme &&
        (this.isMobile || window.document.documentElement.clientWidth <= 1024) &&
        !/OPR/i.test(navigator.userAgent)
      )
    },
    isShowTax() {
      if (this.orderinfo.taxed_price !== undefined) return true
      if (this.payinfo.taxed_price !== undefined && this.isProductionTax) return true
      return false
    },
  },
  // 侦听器
  watch: {},
  // import的组件需要声明
  components: {},
  beforeDestroy() {
    clearTimeout(this.timer)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.custom-header-title {
  line-height: 1;
}
.pay-result-container {
  .tips {
    font-size: 14px;
    color: #62676b;
    text-align: center;
    line-height: 1.2;
    .fail-code {
      ::v-deep(span) {
        color: #df3c3c;
      }
    }
  }
  .pay-result-content {
    margin-top: 12px;
    padding: 4px 12px;
    border-radius: 8px;
    background-color: #f2f4f8;
  }
  .pay-result-section {
    & + .pay-result-section {
      border-top: 1px solid #dde1e6;
      margin-top: 4px;
      padding-top: 4px;
    }
  }
  p {
    padding: 4px 0 5px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    line-height: 15px;
    color: #62676b;
    span:nth-child(2) {
      color: #343a3f;
      font-weight: 500;
      font-family: 'roboto-medium';
      text-align: right;
    }
  }
  .send-to-email {
    cursor: pointer;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #dde1e6;
    margin-top: 4px;
    margin-bottom: -4px;
    font-weight: 500;
    font-size: 16px;
    color: #19b05a;
    .icon {
      width: 32px;
      height: 32px;
      .bg-image('icon_send_email');
    }
  }
}
.footer-container {
  margin-top: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  .button {
    & + .button {
      margin-left: 0 !important;
      margin-top: 12px;
    }
  }
  .icon_logo {
    margin-left: 8px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
  }
}
</style>
